export const daysInMonth = (month, year) => new Date(year, month + 1, 0).getDate();
